import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { SecurityState } from '@shared/store/reducers/security.reducer';
import { isInDemo } from '@shared/store/selectors/security.selector';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

/**
 * ITP-P-54 D2: nothing is bought, sold or cancelled in a demo, so the Marketplace is closed there.
 * Inside a demo a route under this guard sends the user home; outside one it opens as before.
 */
@Injectable({
  providedIn: 'root'
})
export class NotInDemoGuard implements CanActivate {
  constructor(private router: Router, private securityStore: Store<SecurityState>) {
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.securityStore.select(isInDemo).pipe(
      take(1),
      map(inDemo => inDemo ? this.router.createUrlTree(['']) : true)
    );
  }
}
